import { render } from "./WQlook.vue?vue&type=template&id=a25de156&scoped=true"
import script from "./WQlook.vue?vue&type=script&lang=js"
export * from "./WQlook.vue?vue&type=script&lang=js"

import "./WQlook.vue?vue&type=style&index=0&id=a25de156&lang=scss&scoped=true"
import "./WQlook.vue?vue&type=style&index=1&id=a25de156&lang=css"

import exportComponent from "D:\\workCode\\PC\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a25de156"]])

export default __exports__